<ng-container *ngTemplateOutlet="default"></ng-container>

<ng-template #default>
  <div class="action-card action-details-card flex-column space-between mb-lg">
    <div class="flex-column action-card__content">
      <ng-container *ngTemplateOutlet="title"></ng-container>
      <ng-container *ngTemplateOutlet="details"></ng-container>
      <typography-legacy text-small-regular color="var(--secondary-text)" class="action-card__body">{{ cardConfig.body }}</typography-legacy>
      <div class="flex-row space-between action-card_footer_action mt-sm">
        <div class="flex-column">
          <bw-icon-legacy *ngIf="cardConfig.optionalIcon" [iconName]="cardConfig.optionalIcon"></bw-icon-legacy>
        </div>
        <div class="flex-column">
          <div tabindex="1" class="action-card__cta_icon" (click)="emitCtaClicked()" (keyup.enter)="emitCtaClicked()">
            {{ cardConfig.ctaString }}
            <bw-icon-legacy [iconName]="'chevron_right'" color="var(--blue-50)" [size]="24"></bw-icon-legacy>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #title>
  <div class="flex-row action-card__label mb-sm">
    <img *ngIf="cardConfig.labelImg" [src]="cardConfig.labelImg" width="32" class="mr-xs" />
    <bw-icon-legacy
      *ngIf="cardConfig.labelIcon && !cardConfig.labelImg"
      [iconName]="cardConfig.labelIcon"
      [size]="32"
      [horizontalSpace]="'mr-xs'"
    ></bw-icon-legacy>
    <div class="flex-item">
      <typography-legacy *ngIf="cardConfig.title" text-medium-semibold>{{ cardConfig.title }}</typography-legacy>
      <typography-legacy text-xsmall-regular color="var(--secondary-text)">{{ cardConfig.label }}</typography-legacy>
    </div>
  </div>
</ng-template>

<ng-template #details>
  <div class="action-details-card__details mb-sm pb-sm">
    <div *ngFor="let detail of cardConfig.details" class="flex-row space-between mb-xs">
      <typography-legacy text-xsmall-regular color="var(--secondary-text)">{{ detail.title }}</typography-legacy>
      <typography-legacy text-xsmall-semibold>{{ detail.detail }}</typography-legacy>
    </div>
  </div>
</ng-template>
